/* eslint-disable */
export default {
  add: 'Ajouter',
  noCalls: 'Aucun appel disponible',
  activeCall: 'Appel en cours',
} as const;

// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No available calls"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
